import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap } from "rxjs";
import { AlertService } from "src/app/services/alert.service";
import { CommonApiService } from "src/app/services/common-api.service";
import { API } from "../../models/api.enum";
import { IReqGenerateKeyRes } from "../../models/request-genearate-key.model";
import {
  updateActiveStatus,
  updateActiveStatusFailure,
  updateActiveStatusSuccess,
} from "./active-status.action";

@Injectable()
export class UpdateActiveStatusEffects {
  constructor(
    private actions$: Actions,
    private commonApiService: CommonApiService,
    private alertService: AlertService
  ) {}

  updateActiveStatus$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateActiveStatus),
      switchMap(({ userId, status }) => {
        const fullUrl = API.REQ_GENERATE_KEY.replace("{{userId}}", userId);

        const payload = { status };

        return this.commonApiService
          .put<IReqGenerateKeyRes>(fullUrl, payload)
          .pipe(
            map((response) => {
              if (response) {
                this.alertService.alertSuccess("success", response.desc);
                return updateActiveStatusSuccess({ response });
              } else {
                this.alertService.alertDanger(
                  "Update failed",
                  "The API returned an unexpected response format."
                );
                return updateActiveStatusFailure({
                  error: "Check your connection and try again.",
                });
              }
            }),
            catchError((error) => {
              this.alertService.alertDanger(
                "Failed to update status",
                "Check your connection and try again."
              );
              return of(updateActiveStatusFailure({ error }));
            })
          );
      })
    );
  });
}
